import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { formatTimer } from "base/utils";

/**
 * Timer component is timer will start from 0 till timer ends like a stopwatch
 */

export function Timer({ time, showHours = false }) {
  return <>{formatTimer(time, showHours)}</>;
}

Timer.propTypes = {
  /**
   * It will take seconds as input and display it as hours minutes seconds as timer
   */
  time: PropTypes.number,
  /**
   * This prop is used to display the hours in timer
   */
  showHours: PropTypes.bool
};

Timer.defaultProps = {
  showHours: false
};
